import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import QrCode2Icon from "@mui/icons-material/QrCode2";
import {LoadingButton} from "@mui/lab";
import {Button, ButtonGroup} from "@mui/material";
import {useTranslation} from "react-i18next";
import {DigitalSigningFlow} from "./useDigitalSigning";

// The footer's height: as tall as the primary action beside it - both buttons stretch to it
const GROUP_SX = {flexShrink: 0, minHeight: 40};
// Narrow, like the arrows of the reservation dialog's split buttons
const ARROW_SX = {px: 0.5, minWidth: 'auto'};

interface Props {
    flow: DigitalSigningFlow
    /** The folio is saving or another of its actions runs. */
    disabled?: boolean
}

/** Split button in folio footer: main button issues link immediately; dropdown arrow opens configuration dialog. */
const DigitalSigningButton = ({flow, disabled}: Props) => {
    const {t} = useTranslation();

    return (
        <ButtonGroup variant={'outlined'} disabled={disabled || flow.busy} sx={GROUP_SX}>
            <LoadingButton
                startIcon={<QrCode2Icon/>}
                loading={flow.creatingRightAway}
                loadingPosition={'start'}
                aria-haspopup={'dialog'}
                onClick={() => void flow.createRightAway()}
            >
                {t('Get signature')}
            </LoadingButton>
            {/* Named, without a tooltip - like the dialogs' icon buttons */}
            <Button size={'small'} aria-label={t('Link options')} aria-haspopup={'dialog'} onClick={flow.openDialog} sx={ARROW_SX}>
                <ArrowDropDownIcon/>
            </Button>
        </ButtonGroup>
    );
};

export default DigitalSigningButton;
